import cleanedFilename from '~/util/cleanedFilename';

export default {
  ZAPIER_EVENTS_DROPDOWN: `${cleanedFilename(
    __filename,
  )}-zapier-events-dropdown`,
};
